(() => {
  if (window.skBeginnerV2Initialized) return;
  window.skBeginnerV2Initialized = true;
  const observers = new WeakMap();
  function initialize(scope) {
    scope.querySelectorAll('.sk-beginner').forEach(root => {
      if (root.dataset.beginnerReady) return;
      root.dataset.beginnerReady = 'true';
      root.addEventListener('click', event => {
        const button = event.target.closest('.faq-question');
        if (!button || !root.contains(button)) return;
        const item = button.closest('.faq-item');
        const wasOpen = item.classList.contains('open');
        root.querySelectorAll('.faq-item').forEach(other => {
          other.classList.remove('open');
          other.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
          const answer = other.querySelector('.faq-answer');
          answer.style.maxHeight = null;
          answer.inert = true;
        });
        if (!wasOpen) {
          item.classList.add('open');
          button.setAttribute('aria-expanded', 'true');
          const answer = item.querySelector('.faq-answer');
          answer.inert = false;
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
      const resizeObserver = new ResizeObserver(() => {
        const answer = root.querySelector('.faq-item.open .faq-answer');
        if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
      });
      resizeObserver.observe(root);
      observers.set(root, resizeObserver);
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.sk-beginner').forEach(root => observers.get(root)?.disconnect());
  });
})();
